'use strict';

// плагины
//=include vendor/wnumb/wNumb.js
//=include vendor/nouislider/nouislider.min.js
//=include vendor/slick/slick.min.js
//=include vendor/simplebar/simplebar.min.js
//=include vendor/inputmask/jquery.inputmask.min.js
//=include vendor/fancybox/jquery.fancybox.min.js
//=include vendor/bodyScrollLock/bodyScrollLock.min.js
//=include vendor/cookie/cookie.js
//=include vendor/mockjax/jquery.mockjax.min.js
//=include vendor/lazyload/lazyload.js
//=include vendor/datepicker/datepicker.min.js
//=include vendor/tooltipster/tooltipster.bundle.min.js
//=include vendor/datepicker/datepicker.min.js
//=include vendor/dadata/jquery.suggestions.min.js

// аналитика
//=include component/_analytics/script.js

// ui
//=include component/ui/alert/script.js
//=include component/ui/changer/script.js
//=include component/ui/codefield/script.js
//=include component/ui/cut/script.js
//=include component/ui/datepicker/script.js
//=include component/ui/downloader/script.js
//=include component/ui/input-bordered/script.js
//=include component/ui/input-bordered/script.js
//=include component/ui/input-custom/script.js
//=include component/ui/rating/script.js
//=include component/ui/submitter/script.js
//=include component/ui/tabs/script.js
//=include component/ui/tooltip/script.js

// интеграции
//=include component/dadata/script.js
//=include component/recaptcha/script.js

// компоненты
//=include component/modal/collect-email/script.js
//=include component/lazyload/script.js
//=include component/i-form/script.js
//=include component/i-toggle/script.js
//=include component/global-basket/script.js
//=include component/global-loader/script.js
//=include component/site-header/script.js
//=include component/site-footer/script.js
//=include component/site-login/script.js
//=include component/block/input/phone/script.js
//=include component/site-notice/script.js

//=include component/bottom-subscribe/script.js
//=include component/i-select/script.js
//=include component/i-select-gray/script.js
//=include component/i-sort-list/script.js
//=include component/i-textarea/script.js
//=include component/i-input-text/script.js
//=include component/modal/script.js
//=include component/i-btn-fav/script.js
//=include component/i-likes/script.js
//=include component/book-item/script.js
//=include component/modal-warning/script.js
//=include component/carousel-books-regular/script.js
//=include component/carousel-books-tiny/script.js
//=include component/carousel-compilations/script.js
//=include component/carousel-posts/script.js
//=include component/carousel-horizontal-rows2/script.js
//=include component/carousel-events/script.js
//=include component/events-home/script.js
//=include component/feedback-form/script.js
//=include component/message-cookies/script.js
//=include component/modal/accounts-merge/script.js
//=include component/modal/order-promo/script.js

//=include component/modal/menu/account/script.js

//=include component/socmedias/script.js
//=include component/section-kealabs/script.js
//=include component/bonus/badge/script.js
//=include component/video/script.js
